export interface FileIntakeGate {
    filterBatch: (target: string, files: File[]) => File[];
}

export function createFileIntakeGate(windowMs = 1500, maxEntries = 256): FileIntakeGate {
    const seenByTarget = new Map<string, WeakMap<File, number>>();

    const getTargetMap = (target: string): WeakMap<File, number> => {
        const existing = seenByTarget.get(target);
        if (existing) return existing;
        const created = new WeakMap<File, number>();
        seenByTarget.set(target, created);
        return created;
    };

    const prune = (now: number) => {
        // WeakMap entries are GC-managed; only bound the number of target maps.
        if (seenByTarget.size <= maxEntries) return;
        const targets = [...seenByTarget.keys()];
        const overBy = seenByTarget.size - maxEntries;
        for (let i = 0; i < overBy; i += 1) {
            const target = targets[i];
            if (target != null) seenByTarget.delete(target);
        }
    };

    return {
        filterBatch: (target: string, files: File[]): File[] => {
            if (files.length === 0) return [];
            const now = Date.now();
            prune(now);
            const targetMap = getTargetMap(target);
            const accepted: File[] = [];
            for (const file of files) {
                const previous = targetMap.get(file);
                if (previous != null && now - previous <= windowMs) continue;
                targetMap.set(file, now);
                accepted.push(file);
            }
            return accepted;
        }
    };
}
